/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "../../axios";

export default {
  async getContactForms({ commit }) {
    let response = await axios.get("/api/contact/");
    return commit("UPDATE_CONTACT_FORMS", response.data.contactForms);
  }
};
